import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="mobile-menu"
export default class extends Controller {
    static targets = ["menu", "drawer"]

    connect() {
        this.isOpen = false
    }

    toggle() {
        if (this.isOpen) {
            this.close()
        } else {
            this.open()
        }
    }

    open() {
        this.isOpen = true
        this.menuTarget.classList.remove("hidden")
        document.body.style.overflow = 'hidden'
        
        // Use timeout to ensure the transition happens after visibility change
        setTimeout(() => {
            this.drawerTarget.classList.remove("-translate-x-full")
            this.drawerTarget.classList.add("translate-x-0")
        }, 10)
    }

    close() {
        this.isOpen = false
        this.drawerTarget.classList.remove("translate-x-0")
        this.drawerTarget.classList.add("-translate-x-full")
        document.body.style.overflow = ''

        // Wait for transition to finish before hiding container
        setTimeout(() => {
            if (!this.isOpen) {
                this.menuTarget.classList.add("hidden")
            }
        }, 300) // Match duration-300
    }
}

